import React from 'react';
import { oohData } from '../utils/oohData';
import { ZapIcon, CheckCircleIcon, AlertTriangleIcon } from 'lucide-react';
export const ExecutiveSummary: React.FC = () => {
  const {
    headlineVerdict,
    topStrengths,
    topImprovements
  } = oohData;
  return <div className="bg-white rounded-xl shadow-sm border-t-4 border-t-[#1E90FF] p-6" data-id="element-211" data-mp="219521bgko1lu">
      {/* Headline verdict */}
      <div className="flex items-start space-x-3 mb-8" data-id="element-212" data-mp="1w90onuaynmzu">
        <div className="p-2 bg-[#1E90FF]/10 rounded-lg flex-shrink-0" data-id="element-213" data-mp="18m2bb5i50v65">
          <ZapIcon className="h-5 w-5 text-[#1E90FF]" data-id="element-214" data-mp="14k76hr0zzznm" />
        </div>
        <div data-id="element-215" data-mp="14hul13w1775t">
          <p className="text-xs font-semibold text-[#1E90FF] uppercase tracking-wider mb-1" data-id="element-216" data-mp="1iasjx07onhe4">
            Executive Summary
          </p>
          <h2 className="text-xl md:text-2xl font-semibold text-gray-900 leading-tight" data-id="element-217" data-mp="1djk9c0um9pzd">
            {headlineVerdict}
          </h2>
        </div>
      </div>

      {/* Working vs Fixes — each item is self-explanatory, no hover needed */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-218" data-mp="ktu3sg71vwev">
        {/* What's working */}
        <div className="bg-green-50/50 border border-green-100 rounded-xl p-5" data-id="element-219" data-mp="1zs5c9xb1u9f5">
          <div className="flex items-center space-x-2 mb-4" data-id="element-220" data-mp="24rrmdxvkz9jq">
            <CheckCircleIcon className="export-icon-down h-5 w-5 text-green-600" data-id="element-221" data-mp="29jsx3fd3os7n" />
            <h3 className="text-sm font-semibold text-green-800 uppercase tracking-wider" data-id="element-222" data-mp="2eiw3p48qb6hq">
              What’s working
            </h3>
          </div>
          <ul className="space-y-3" data-id="element-223" data-mp="1gwyj91asgr35">
            {topStrengths.map((strength, idx) => <li key={idx} className="flex items-start space-x-3" data-id="element-224" data-mp="1lv0a48eghup6" data-mpi={idx}>
                <span className="export-dot-down mt-1.5 w-1.5 h-1.5 rounded-full bg-green-500 flex-shrink-0" data-id="element-225" data-mp="1qtbjyj4r457e" />
                <p className="text-sm text-gray-700 leading-relaxed" data-id="element-226" data-mp="1uw7urno1ux0s">
                  <span className="font-semibold text-gray-900" data-id="element-227" data-mp="32905r769qy6m">
                    {strength.name}.
                  </span>{' '}
                  {strength.summary}
                </p>
              </li>)}
          </ul>
        </div>

        {/* Priority fixes */}
        <div className="bg-amber-50/60 border border-amber-200 rounded-xl p-5" data-id="element-228" data-mp="177eny8jatijh">
          <div className="flex items-center space-x-2 mb-4" data-id="element-229" data-mp="1267fs8d8uhca">
            <AlertTriangleIcon className="export-icon-down h-5 w-5 text-amber-600" data-id="element-230" data-mp="1g572hah74m5t" />
            <h3 className="text-sm font-semibold text-amber-800 uppercase tracking-wider" data-id="element-231" data-mp="1b6nhbcaffeei">
              Priority fixes
            </h3>
          </div>
          <ol className="space-y-3" data-id="element-232" data-mp="nhuin82f6sg7">
            {topImprovements.map((improvement, idx) => <li key={idx} className="flex items-start space-x-3" data-id="element-233" data-mp="jhu0pdg43z4e" data-mpi={idx}>
                <span className="mt-0.5 flex-shrink-0 flex items-center justify-center w-5 h-5 rounded-full bg-amber-500 text-white text-[11px] font-bold leading-none" data-id="element-234" data-mp="x8fkd4de4d3c">
                  <span className="export-text-up" data-id="element-235" data-mp="4qtfe7u9oaqu">{idx + 1}</span>
                </span>
                <p className="text-sm text-gray-700 leading-relaxed" data-id="element-236" data-mp="3vxe7luw25opg">
                  <span className="font-semibold text-gray-900" data-id="element-237" data-mp="3vvbgt8n2zrjo">
                    {improvement.name}.
                  </span>{' '}
                  {improvement.summary}
                </p>
              </li>)}
          </ol>
        </div>
      </div>
    </div>;
};